// extracted by mini-css-extract-plugin
export default {"userTile":"UserTile_userTile__+uZX-","createBox":"UserTile_createBox__6AX4E","userHeader":"UserTile_userHeader__VXA-b","profilePic":"UserTile_profilePic__IVYux"};